import React, { useEffect, useMemo, useRef, useState } from "react";
import "./TokenPage.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ClipLoader, PulseLoader } from "react-spinners";
import LoadingLogo from "../../Components/LoadingLogo/LoadingLogo";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { baseUrl } from "../../config/endpoints";
import { toast } from "react-toastify";

function TokenPage() {
  const email = sessionStorage.getItem("email");
  const [otp, setOtp] = useState(Array(6).fill(""));

  const [activeOtpBox, setActiveOtpBox] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const otpInputRef = useRef(null);
  const { userCode, uniqueID } = useParams();
  const [isLoadingResend, setIsLoadingResend] = useState(false);
  const isOtpValid = useMemo(() => {
    return otp.every((it) => it !== "");
  }, [otp]);

  useEffect(() => {
    otpInputRef?.current?.focus();
  }, [activeOtpBox]);

  const handleOtpChange = (event, index) => {
    const result = event.target.value.replace(/\D/g, "");
    if (!result.length) {
      return;
    }
    const newOtp = [...otp];
    newOtp[index] = result[result.length - 1] ?? "";
    setOtp(newOtp);
    if (!result.length) {
      if (activeOtpBox > 0) {
        setActiveOtpBox((current) => current - 1);
      }
    }
    if (activeOtpBox < otp.length) {
      if (activeOtpBox < otp.length - 1) {
        setActiveOtpBox((current) => current + 1);
      }
    }
  };

  const handleKeyDown = (event, index) => {
    if (
      ["ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "e"].includes(
        event.key,
      )
    ) {
      event.preventDefault();
    }
    if (event.key === "Backspace") {
      const value = event.target?.value;
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      if (value === "" && activeOtpBox > 0) {
        setActiveOtpBox((current) => current - 1);
      }
    }
  };

  const handleFocus = (event, index) => {
    if (activeOtpBox !== index) {
      otpInputRef?.current?.focus();
    }
  };

  const handleOtpSubmitClicked = async () => {
    const requestId = sessionStorage.getItem("reference");
    const payload = {
      token: otp.join(""),
      uniqueID: uniqueID,
      usercode: userCode,
      requestId
    };

    setIsLoading(true);
    try {
      const response = await axios.post(
        baseUrl + "/hangouts/smelab/business/registration",
        payload,
      );
      if (response?.data?.accountRespCode === "00") {
        navigate(
          `/success/${response?.data?.response?.AccountNUBAN}/${response?.data?.response?.CustomerNumber}`,
        );
      } else if (response?.data?.code === null) {
        Swal.fire({
          title: "Error",
          text: response.data.message,
          icon: "error",
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      Swal.fire({
        title: "Error",
        text: e.message,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    const payload = {
      uniqueID: uniqueID,
    };

    setIsLoadingResend(true);
    try {
      const response = await axios.post(
        baseUrl + "/hangouts/smelab/business/resendOTP",
        payload,
      );
      if (response?.data?.code === "00") {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e.message);
      // Swal.fire({
      //   title: "Error",
      //   text: e.message,
      //   icon: "error",
      // });
    } finally {
      setIsLoadingResend(false);
    }
  };
  return (
    <div className="token_back">
      <div className="token">
        <div className="token_header">
          <p>Please, type in the code we sent to</p>
          <span className="token_email">{email}</span>
        </div>
        <div className="token_input">
          <div className="otp-boxes">
            {otp?.map((_, index) => (
              <div key={`input-${index}]`} className="otp-container">
                <input
                  className="token-box"
                  type="number"
                  value={otp[index] ?? ""}
                  onChange={(e) => handleOtpChange(e, index)}
                  ref={index === activeOtpBox ? otpInputRef : null}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onFocus={(e) => handleFocus(e, index)}
                />
                {index === otp.length - 1 ? null : (
                  <span className="otp-dash">-</span>
                )}
              </div>
            ))}
          </div>
        </div>
        <button
          disabled={!isOtpValid}
          className="otp-submit-btn"
          onClick={handleOtpSubmitClicked}
        >
          {isLoading ? <PulseLoader color="#fffff" /> : "Continue"}
        </button>
        <p className="retry_text">Didn't get otp?</p>
        <p className="retry_otp" onClick={() => handleResendOtp()}>
          {" "}
          {isLoadingResend ? (
            <ClipLoader color="#fbb900" size="15px" />
          ) : (
            "Resend otp"
          )}{" "}
        </p>
      </div>

      {isLoading ? <LoadingLogo /> : null}
    </div>
  );
}

export default TokenPage;
